import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, ArrowRight } from "lucide-react";

export default function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@ieftinit.ro");
  const [password, setPassword] = useState("Admin@123");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success(`Bine ai venit, ${res.user.name}!`);
      navigate("/");
    } else {
      toast.error(res.error || "Autentificare eșuată");
    }
  };

  return (
    <div className="min-h-screen flex bg-background text-foreground">
      {/* Left - hero */}
      <div className="hidden lg:flex w-1/2 relative grid-bg overflow-hidden bg-secondary/30">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-transparent" />
        <div className="relative z-10 flex flex-col justify-between p-12 w-full">
          <div className="flex items-center gap-3">
            <img src="/ieftinit-logo.png" alt="IEFTINIT.RO" className="h-12 w-auto object-contain" />
            <div className="leading-tight">
              <div className="font-display font-black text-xl tracking-tight">IEFTINIT.RO</div>
              <div className="text-[10px] text-muted-foreground uppercase tracking-[0.2em] font-semibold">Control Hub</div>
            </div>
          </div>
          <div>
            <h1 className="font-display text-5xl xl:text-6xl font-bold tracking-tight text-balance">
              Operațiuni Shopify <br /><span className="text-primary">la viteza gândului.</span>
            </h1>
            <p className="text-muted-foreground mt-6 text-base max-w-md leading-relaxed">
              Un singur hub pentru retururi, comenzi, livrări și suport. Construit pentru echipe care nu au timp de pierdut.
            </p>
            <div className="mt-10 grid grid-cols-3 gap-4 max-w-sm">
              {[["—", "Module"], ["RO", "Limba"], ["v0.1", "Build"]].map(([v, l]) => (
                <div key={l} className="border-l border-border pl-3">
                  <div className="font-display font-bold text-2xl">{v}</div>
                  <div className="text-[10px] text-muted-foreground uppercase tracking-widest font-medium mt-1">{l}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="text-xs text-muted-foreground">© 2026 IEFTINIT.RO · Toate drepturile rezervate</div>
        </div>
      </div>

      {/* Right - form */}
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-3 mb-10">
            <img src="/ieftinit-logo.png" alt="IEFTINIT.RO" className="h-10 w-auto object-contain" />
            <div className="font-display font-black text-xl">IEFTINIT.RO</div>
          </div>

          <div className="mb-8">
            <div className="text-xs uppercase tracking-widest text-muted-foreground font-semibold mb-2">Autentificare</div>
            <h2 className="font-display text-3xl font-bold tracking-tight">Bine ai revenit.</h2>
            <p className="text-muted-foreground text-sm mt-2">Introdu datele tale pentru a accesa Control Hub.</p>
          </div>

          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="nume@ieftinit.ro"
                required
                className="h-11"
                data-testid="login-email"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Parolă</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="h-11"
                data-testid="login-password"
              />
            </div>
            <Button type="submit" className="w-full h-11 group" disabled={loading} data-testid="login-submit">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : (
                <>Intră în Control Hub <ArrowRight className="h-4 w-4 ml-2 group-hover:translate-x-0.5 transition-transform" /></>
              )}
            </Button>
          </form>

          <div className="mt-8 p-4 rounded-lg border border-dashed border-border bg-secondary/30">
            <div className="text-[10px] uppercase tracking-widest text-muted-foreground font-semibold mb-2">Conturi demo</div>
            <div className="text-xs text-muted-foreground space-y-1 font-mono">
              <div>admin@ieftinit.ro · Admin@123</div>
              <div>manager@ieftinit.ro · Manager@123</div>
              <div>agent@ieftinit.ro · Agent@123</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
